import { CONTRACT_SIGNATORY_TYPE, type ContractSignatory } from "@academy-context/shared/domain/types/contract-signatory";
import type { Nullable } from "@shared-kernel/core/types/nullable";

interface PersonName {
  firstName: string;
  lastName: string;
}

export const formatPersonName = ({ firstName, lastName }: PersonName): string => `${firstName} ${lastName}`;

export const formatLegalRepresentativeName = (legalRepresentative: Nullable<PersonName>): string =>
  legalRepresentative ? formatPersonName(legalRepresentative) : "Non renseigné";

/** Who signs the subcontracting contract, as one line. The legal representative signs with the provider's email. */
export const describeContractSignatory = (
  signatory: ContractSignatory,
  legalRepresentative: Nullable<PersonName>,
  providerEmail: string,
): string => {
  const legalRepresentativeName = formatLegalRepresentativeName(legalRepresentative);
  if (signatory.type === CONTRACT_SIGNATORY_TYPE.LEGAL_REPRESENTATIVE) {
    return `${legalRepresentativeName}, représentant légal (${providerEmail})`;
  } else if (signatory.type === CONTRACT_SIGNATORY_TYPE.DELEGATE) {
    return `${formatPersonName(signatory)} (${signatory.email}), en délégation du représentant légal ${legalRepresentativeName}`;
  } else {
    const unhandledSignatory: never = signatory;
    throw new Error(`Unknown contract signatory type. Signatory: ${JSON.stringify(unhandledSignatory)}.`);
  }
};
